exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".app-header .navbar-nav .dropdown-menu-right{right:auto}\n", "", {"version":3,"sources":["/Users/ionut/Work/Mycontracts/mycontracts-ui/scss/core/_dropdown-menu-right.scss"],"names":[],"mappings":"AACA,6CAGM,UAAW,CAAA","file":"_dropdown-menu-right.scss","sourcesContent":["// Temp fix for reactstrap\n.app-header {\n  .navbar-nav {\n    .dropdown-menu-right {\n      right: auto;\n    }\n  }\n}\n"],"sourceRoot":""}]);

// exports
